/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_ImportInputs */



/**
* | output |
* | --- |
* | "Batch Import" |
*
* @param {Batch_ImportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_import = /** @type {((inputs?: Batch_ImportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_ImportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation par lots")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stapelimport")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione in batch")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пакетный импорт")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación por lotes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("批量导入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("バッチインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बैच आयात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação em lote")
	return /** @type {LocalizedString} */ ("Batch Import")
});